// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import Table from '@/components/table';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import KendoPager from '@/components/kendo/kendo-pager';
import Pagination from '@/components/pagination';
import Fetch from '@/utils/Fetch';
import Router from 'next/router';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
// filtersConfig code
import UCS from '@/services/option/user-config-service';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoTable from '@/components/kendo/kendo-table';
// filtersConfig code
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'



const COLUMNS = [{
  Label: 'Name',
  ColumnName: 'Description',
  CellType: 'none',
}, {
  Label: 'Inventory Category',
  ColumnName: 'InventoryCategoryDescription',
  CellType: 'status',
}, {
  Label: 'Account Code',
  ColumnName: 'Code',
  CellType: 'none',
}, {
  Label: 'Updated By',
  ColumnName: 'ModifiedBy',
  CellType: 'none',
}, {
  Label: 'Updated Date',
  ColumnName: 'ModifiedDate',
  CellType: 'date',
}];

const INCLUDE_DISABLED_FILTER = [{
  type: Enums.ControlType.Switch,
  label: 'Include disabled subcategories',
}];

function InventorySubcategoryList() {

  const [columnState, setColumnState] = useState(COLUMNS);
  const [inventorySubcategoryResults, setInventorySubcategoryResults] = useState([{}]);

  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searching, setSearching] = useState(false);
  const [searchVal, setSearchVal] = useState('');
  const [activeFilterIds, setActiveFilterIds] = useState({ Categories: [] });
  const [ancillaryFilters, setAncillaryFilters] = useState({ IncludeDisabled: false });
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // filtersConfig code
  const [filtersConfig, setFiltersConfig] = useState<any>(null);
  // filtersConfig code

  const [filters, setFilters] = useState<any>({});

  const { data: filtersConfigData } = useQuery(
    ['inventorySubcategoryFiltersConfig'],
    () => UCS.getPageFilters(Enums.ConfigurationSection.InventorySubcategory)
  );

  useEffect(() => {
    if (filtersConfigData && !filtersConfig) {
      const [activeIds, ancillaryDefaults, sortExp, sortDir] = UCS.getFilterValues(filtersConfigData,
        ["Categories"], [],
        ["IncludeDisabled"], false);
      setFiltersConfig(filtersConfigData);
      setActiveFilterIds(activeIds);
      setAncillaryFilters(ancillaryDefaults);
      setSortField(sortExp);
      setSortDirection(sortDir);
    }
  }, [filtersConfigData]);

  const { data: inventoryCategoriesData } = useQuery(
    ['inventoryCategoriesForFilter'],
    () => Fetch.get({ url: `/InventoryCategory/false` })
  );

  useEffect(() => {
    if (inventoryCategoriesData?.Results) {
      setFilters({ Categories: inventoryCategoriesData.Results });
    }
  }, [inventoryCategoriesData]);

  const handleAncillaryFilterChange = (result: any) => {
    if (result.reset) {
      setAncillaryFilters({ IncludeDisabled: false });
    } else {
      if (result.key == "IncludeDisabled") {
        setAncillaryFilters({ IncludeDisabled: result.checked });
      }
    }
  };

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const [pageSize, setPageSize] = useState(10);

  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    if (currentPage == 1) {
      searchInventorySubcategories();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, activeFilterIds, ancillaryFilters, pageSize]);

  useEffect(() => {
    searchInventorySubcategories();
  }, [currentPage]);

  async function searchInventorySubcategories() {
    setSearching(true);

    const inventorySubcategories = await Fetch.post({
      url: `/InventorySubcategory/GetInventoryCategories`,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        CategoryIDList: activeFilterIds["Categories"],
        IncludeClosed: ancillaryFilters["IncludeDisabled"],
        SortExpression: sortField,
        SortDirection: sortDirection,
      }
    });

    // filtersConfig code
    let filtersConfigTemp = { ...filtersConfig };
    UCS.updateFilters(filtersConfigTemp, activeFilterIds, ancillaryFilters, sortField, sortDirection);
    UCS.saveConfigDebounced(filtersConfigTemp);
    setFiltersConfig(filtersConfigTemp);
    // filtersConfig code

    setInventorySubcategoryResults(inventorySubcategories.Results);
    setTotalResults(inventorySubcategories.TotalResults);

    setSearching(false);
  }

  const columns = React.useMemo(
    () => columnState.map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
      }

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} />
            break;
        }
      }

      return columnObject;
    }),
    [columnState]
  );

  // for table resize columns
  async function onColumnResize(columnName: any, width: any, columnNamesAndWidths: any) {
    const newState = columnState.map(function (column: any) {
      if (column.ColumnName === columnName) {
        column.UserWidth = width;
      } else if (columnNamesAndWidths) {
        let match = columnNamesAndWidths.find((x: any) => x.columnName === column.ColumnName);
        if (match) {
          column.UserWidth = match.width;
        }
      }
      return column;
    });
    setColumnState(newState);
  }
  // for table resize columns

  function setSort(field: any) {
    if (field != sortField) {
      setSortDirection('ascending');
    } else {
      if (sortDirection == 'ascending') {
        setSortDirection('descending');
      } else {
        setSortDirection('ascending');
      }
    }
    setSortField(field);
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push, '/inventory-subcategory/[id]', `/inventory-subcategory/${row.original.ID}`);
  }

  const createSubcategory = () => {
    Helper.nextRouter(Router.push, "/inventory-subcategory/create");
  };

  return (
    <div className="list-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Inventory Subcategory List', link: '/inventory-subcategory/list', type: 'list' }} />
        </div>
        <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
          text="Create" icon="plus-circle" extraClasses="fit-content no-margin" onClick={createSubcategory} />
      </div>
      <div className="row end">
        <div className="search-container">
          <Search
            filters={filters}
            placeholder="Search inventory subcategory"
            resultsNum={inventorySubcategoryResults.length}
            searchVal={searchVal}
            setActiveFilterIds={setActiveFilterIds}
            ancillaryFilters={INCLUDE_DISABLED_FILTER}
            setAncillaryFilters={handleAncillaryFilterChange}
            setSearchVal={setSearchVal}
            filtersConfig={filtersConfig}
          />
        </div>
      </div>

      <div className={"no-items" + (inventorySubcategoryResults.length == 0 ? " no-items-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <img src="/job-folder.svg" alt="Folder" />
        <h3>No Inventory Subcategory found</h3>
        <p>If you can't find a Inventory Subcategory, try another search or create a new one.</p>
        <a href="/inventory-subcategory/create"><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new Inventory Subcategory</a>
        <img className="wave" src="/wave.svg" alt="wave" />
      </div>

      {/* <div className={"table-container" + (inventorySubcategoryResults.length != 0 ? " table-container-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <Table actions={[
          { text: "Edit", icon: "edit", function: (row) => Helper.nextRouter(Router.push, '/inventory-subcategory/[id]', `/inventory-subcategory/${row.ID}`) },
        ]}
          columns={columns} data={inventorySubcategoryResults} setSort={setSort} sortField={sortField} sortDirection={sortDirection} rowClick={rowClick} />
      </div> */}

      <div className="margin-top">
        {inventorySubcategoryResults.length != 0 ? <KendoTable
          searching={searching}
          actions={[
            { text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push, '/inventory-subcategory/[id]', `/inventory-subcategory/${row.ID}`) },
          ]}
          columns={columns}
          data={inventorySubcategoryResults}
          rowClick={rowClick}
          setSort={setSort}
          sortField={sortField}
          sortDirection={sortDirection}
          type="InventorySubcategory"
          // for table resize columns
          onColumnResize={onColumnResize}
          // for table resize columns
          canSelectItems={false}
          heightOffset={295}
          highlightColumnName="Description"
        /> : ""}
      </div>

      <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal}  parentPageNumber={currentPage}/>

      <style jsx>{`
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 13rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }        
        .margin-top {
          margin-top: 0.5rem;
        }     
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default InventorySubcategoryList

export const Route = createFileRoute('/_authenticated/inventory-subcategory/list')({ component: InventorySubcategoryList })
